import block from './block.json';

export const subsectionHeaderThemeAttributes = {
	title: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.heading-1',
		textAlignment: 'left',
	},
};

export const SubsectionHeaderThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: subsectionHeaderThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
